<div class="flex max-w-[552px] flex-col justify-center self-stretch text-sm text-stone-950">
  <div
    class="flex w-full justify-between gap-3 border-b border-solid border-zinc-300 px-5 text-xs font-semibold leading-5 max-md:max-w-full max-md:flex-wrap"
  >
    <div>Buy In Cost:</div>
    <div>{{ buyInCost }}</div>
  </div>
  <div
    class="mt-2 flex w-full justify-between gap-3 border-b border-solid border-zinc-300 px-5 text-xs font-semibold leading-5 max-md:max-w-full max-md:flex-wrap"
  >
    <div>Fold Cost:</div>
    <div>{{ foldCost }}</div>
  </div>
  <div
    class="mt-2 flex w-full justify-between gap-3 border-b border-solid border-zinc-300 px-5 text-xs font-semibold leading-5 max-md:max-w-full max-md:flex-wrap"
  >
    <div>Min Bet:</div>
    <div>{{ minBet }}</div>
  </div>

  <div
    class="mt-2 flex w-full justify-between gap-3 border-b border-solid border-zinc-300 px-5 text-xs font-semibold leading-5 max-md:max-w-full max-md:flex-wrap"
  >
    <div>Max Bet:</div>
    <div>{{ maxBet }}</div>
  </div>

  <div
    class="mt-2 flex w-full justify-between gap-3 border-b border-solid border-zinc-300 px-5 text-xs font-semibold leading-5 max-md:max-w-full max-md:flex-wrap"
  >
    <div>Goal:</div>
    <div>Win the pot and secure as many chips as possible!</div>
  </div>

  <div class="mt-2 w-full font-medium leading-[140%] max-md:max-w-full">Mechanics:</div>
  <div class="mt-2 flex gap-0 pr-5 font-medium max-md:flex-wrap">
    <div class="self-start leading-[140%]">A.</div>
    <div class="flex-1 leading-5 max-md:max-w-full">
      The round starts when the Dealer announces BUY IN OPEN and the Players click the BUY IN
      BUTTON.
    </div>
  </div>
  <div class="mt-2 flex gap-0 pr-5 font-medium leading-[140%] max-md:flex-wrap">
    <div>B.</div>
    <div class="flex-1 max-md:max-w-full">The Dealer draws two Base Cards.</div>
  </div>
  <div class="mt-2 flex gap-0 pr-5 font-medium leading-[140%] max-md:flex-wrap">
    <div>C.</div>
    <div class="flex-1 max-md:max-w-full">The Dealer announces DEAL OPEN for Playing Seat.</div>
  </div>
  <div class="mt-2 flex gap-0 pr-5 max-md:flex-wrap">
    <div class="self-start font-medium leading-[140%]">D.</div>
    <div class="flex flex-1 flex-col max-md:max-w-full">
      <div class="flex-1 leading-5 max-md:max-w-full">
        The Players on the Playing Seats make their choices.
      </div>
      <div class="mt-2.5 flex gap-2.5 leading-[140%] max-md:flex-wrap">
        <div class="font-bold">Call -</div>
        <div class="flex-1 font-medium max-md:max-w-full">
          the Player bets the
          <span class="font-bold">Maverick Card</span>
          is
          <span class="font-bold">In Between the two Base Cards</span>
          .
        </div>
      </div>
      <div class="mt-2.5 flex gap-2.5 max-md:flex-wrap">
        <div class="self-start font-bold leading-[140%]">Higher -</div>
        <div class="flex-1 font-medium leading-5 max-md:max-w-full">
          the Player bets the
          <span class="font-bold">Maverick Card</span>
          is
          <span class="font-bold">higher than the Pair of Base Cards</span>
          .
        </div>
      </div>
      <div class="mt-2.5 flex gap-2.5 max-md:flex-wrap">
        <div class="self-start font-bold leading-[140%]">Lower -</div>
        <div class="flex-1 font-medium leading-5 max-md:max-w-full">
          the Player bets the
          <span class="font-bold">Maverick Card</span>
          is
          <span class="font-bold">lower than the Pair of Base Cards</span>
          .
        </div>
      </div>
      <div class="mt-2.5 flex gap-2.5 leading-[140%] max-md:flex-wrap">
        <div class="font-bold">Fold -</div>
        <div class="flex-1 font-medium max-md:max-w-full">
          the Player does not bet but pays the
          <span class="font-bold">Fold Cost</span>
          , if any.
        </div>
      </div>
    </div>
  </div>
  <div class="mt-2 flex gap-0 pr-5 font-medium leading-[140%] max-md:flex-wrap">
    <div>E.</div>
    <div class="flex-1 max-md:max-w-full">
      The Dealer draws the Maverick Card and announces the result.
    </div>
  </div>
  <div class="mt-2 flex gap-0 pr-5 font-medium max-md:flex-wrap">
    <div class="self-start leading-[140%]">F.</div>
    <div class="flex-1 leading-5 max-md:max-w-full">
      The Dealer repeats the process until all Seats are called. Then the next Round starts.
    </div>
  </div>
  <button
    class="mt-6 justify-center self-end whitespace-nowrap rounded-lg border border-solid border-zinc-800 px-4 py-1 font-semibold leading-[140%] text-zinc-800 hover:bg-gray-200"
    (click)="closeModal()"
  >
    Close
  </button>
</div>
